<dp-section-form-header [section]="section"></dp-section-form-header>

<dp-header [leftActions]="leftActions" [rightActions]="rightActions" [moreMenuGroups]="moreMenuGroups"></dp-header>

<dp-search [searchAvailableOptions]="searchAvailableOptions" [showSavedSearchButtons]="false" [hidden]="!isSearchVisible()"
    [searchConfig]="searchConfig" (searchInfo)="sendSearch($event)" (clearResults)="clearSearch()" (hide)="hideSearch()">
</dp-search>